import React, { useState } from 'react'
import { _Object } from 'utils/interfaces'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEyeSlash, faEye } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom'
import { InputText } from 'primereact/inputtext'
import { Message } from 'primereact/message'

const InputField = ({
  name,
  type = 'text',
  onChange,
  onBlur,
  value,
  label,
  placeholder = "Enter here",
  required = false,
  className = '',
  icon = '',
  error,
  linkLabel = '',
  linkDisable = false,
  linkOnChange,
  ...props
}: _Object) => {

  const [eyeOn, setEyeOn] = useState(false)
  const [fieldType, setFieldType] = useState(type)

  const toggleEyeOn = () => {
    setEyeOn(!eyeOn)
    setFieldType(eyeOn ? 'password' : 'text')
  }

  return (
    <div className={`form-group mb-2 ${className}`}>
      <div className="d-flex justify-content-between genral-label">
        {label && <label className="label-form mb-1">{label} {required && <span className="required-field">*</span>}</label>}
        {linkLabel?.length > 0 && <Link to="#" onClick={linkOnChange} className={`primary text-decoration-none ${linkDisable ? '' : 'disabled-link'}`}>{linkLabel}</Link>}
      </div>

      <InputText
        {...props}
        type={fieldType}
        autoComplete="off"
        name={name}
        placeholder={placeholder}
        value={value ?? ''}
        onBlur={onBlur}
        onChange={onChange}
        className={`form-control ${error && 'invalid'}`}
      />

      {icon && <img src={icon} alt="Icon" className="position-absolute translate-middle-y form-control-icon top-50 px-3" />}

      {type === 'password' &&
        <button
          type="button"
          className="btn me-3 translate-middle-y p-0 border-0 show-password"
          onClick={toggleEyeOn}
        >
          {eyeOn ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
        </button>
      }
      {error && <Message severity="error" text={error} />}
    </div>
  )
}

export default InputField
